<template>
  <div class="upload">
    <el-upload
      class="upload-demo"
      ref="upload"
      accept=".txt"
      name="batchFilename"
      :data="params"
      :action="uploadOptions.action"
      :headers="uploadOptions.headers"
      :auto-upload="uploadOptions.autoUpload"
      :on-change="change"
      :limit="1"
    >
      <el-button size="small" type="primary">批量导入</el-button>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "BaseUpload",
  props: {
    uploadUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      uploadOptions: {
        action: process.env.VUE_APP_BASE_API + this.uploadUrl,
        headers: {
          token: this.$store.getters.token,
        },
        // 选取文件后立即进行上传
        autoUpload: false,
      },
      params: {
        ukey: undefined,
        userid: undefined,
      }
    };
  },
  created() {
    const { user: { pwd, userid } } = JSON.parse(localStorage.wps);
    this.params = {
      ukey: pwd,
      userid: userid,
    };
  },
  methods: {
    change(file) {
      let reader = new FileReader();
      let line = [];
      let that = this;
      reader.onload = function () {
          
        let result = reader.result;
        if (result) {
          //打印文件内容
          line = result.split(/[(\r\n)\r\n]+/);
          line.forEach((item, index) => {
            if(!item){
              line.splice(index,1);//删除空项
            } else {
              line[index] = line[index].split('|')
            }
          })
         that.$emit('txtContent', line);
        }
      };
      reader.readAsText(file.raw)
      this.$refs.upload.clearFiles();
    },
  },
};
</script>

<style scoped>
.upload {
  margin-right: 20px;
}

::v-deep .el-upload-list--text {
  display: none;
}
</style>
